import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import plusCircle from '../../images/common/plus_circle.svg';

const Button = styled.button`
  width: ${props => props.size};
  height: ${props => props.size};
  padding: 0;
  border: none;
  background-color: inherit;
  borderradius: 50%;
  transition: background-color 0.3s;
`;

const ButtonImage = styled.img`
  width: ${props => props.size};
  height: ${props => props.size};
`;

/**
 * 追加ボタンのUIコンポーネント
 *
 * ボタンをクリックすると、親コンポーネントによって提供されたコールバック関数が呼び出される
 *
 * @prop {function} onClick - ボタンがクリックされたときに実行されるコールバック関数
 *
 * @example
 * <PlusCircleButton onClick={handleClick} size={size} />
 *
 * @returns {ReactElement}
 */
const PlusCircleButton = ({ size, onClick }) => (
  <Button onClick={onClick} className="button" size={size}>
    <ButtonImage src={plusCircle} size={size} />
  </Button>
);

PlusCircleButton.propTypes = {
  size: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};
PlusCircleButton.defaultProps = {
  size: '40px',
};

export default PlusCircleButton;
